import { isFlagInGA, pushFlagToDatalayer } from './gtmEvents'

export function pushTrackedFlagToDataLayer({ flagsToGA, ldFlag, ...props }) {
  if (!isFlagInGA({ flagsToGA, ldFlag })) return
  pushFlagToDatalayer({
    ldFlag,
    ldVariation: flagsToGA[ldFlag],
    ...props
  })
}

export const pushAllGAFlagsToDataLayer = flagsToGA => {
  Object.entries(flagsToGA).forEach(([ldFlag, ldVariation]) => pushFlagToDatalayer({ ldFlag, ldVariation }))
}
